import { Factory } from './Factory'
import Menu from '../EditorComponents/Separator/Menu'

export class SeparatorFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('separator'),
      iconId: this.id('icon-separator'),
      iconContainerId: this.id('icon-container-separator'),
      textId: this.id('text-separator'),
      slug: 'editor-separator',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      contentClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      textClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: 'Separator',
    }
  }

  properties() {
    return {
      content: [
        {key: 'separator-type', component:'ContentType', text:'Type'},
        {key: 'icon-content', component:'ContentIcon'},
      ],
      styles: [
        {key: 'border', component: 'BorderProperty', class: 'contentClasses'},
      ],
      iconStyles: [
        {key: 'border-color', component: 'BorderProperty', class: 'iconContainerClasses', styles:'iconContainerStyles'},
        {key: 'rounded', component: 'RoundedProperty', class: 'iconContainerClasses'},
        {key: 'text-color', component: 'TextColorProperty', styles: 'iconStyles'},
      ],
      textStyles: [
        {key: 'text-color', component: 'TextColorProperty', styles: 'textStyles'},
        {key: 'font-weight', component: 'FontWeightProperty', class: 'textClasses'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
